<template>
  <div class="select-field">
    <select
      :id="id"
      class="form-select"
      @input="emitInput"
    >
      <option :selected="value === ''" hidden>{{ placeholder }}</option>
      <option
        v-for="(option, index) in options"
        :key="`select-field-${name}-${index}`"
        :value="option.value"
        :selected="option.value === value"
        :disabled="option.disabled"
        >
          {{ option.label }}
        </option>
    </select>
      <p v-if="text" class="component_text">{{text}}</p>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
      value: {
          type: String,
          default: ''
      },
      text: {
        type: String,
          default: ''
      }
  },
  methods: {
    emitInput(ev) {
      this.$emit('input', { name: this.name, value: ev.target.value })
    }
  }
}
</script>

<style>
.component_text  {
    background: gray;
    border: 1px solid black;
    box-shadow: 5px 5px 5px lightslategray;
    color:white;
    padding: 5px;
}
</style>
